export enum DisplayOptions {
	DAY = 'day',
	WEEK = 'week',
	MONTH = 'month',
	YEAR = 'year',
	FULL = 'full'
}